import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { SohoMessageService, SohoSwapListComponent } from 'ids-enterprise-ng';
import { LMDialogButtonKey, LMUniqueIdService } from '../../../utils';

@Component({
  selector:    'lm-cube-dimensions-dialog',
  templateUrl: 'lm-cube-dimensions-dialog.component.html',
  styleUrls:   [ 'lm-cube-dimensions-dialog.component.scss' ]
})

// export type LMCubeDimensionParent = 'cubeviewer' | 'reportpersonalization';

export class LMCubeDimensionsDialogComponent implements OnInit {
  @Input() listSpec: LMListSpec;
  @Input() dataViewSet: LMDataViewSet;
  @Input() listState: LMListState;
  @Input() parentContainer: string;

  public labelAvailable: string;
  public labelSelected: string;
  public labelLevels: string;
  public labelSuppressZeros: string;
  public labelSuppressCurPeriod: string;
  public labelShowTotal: string;
  public labelPivotName: string;
  public labelPreservePD: string;

  private periodDimCheck: string;
  private periodDimCheck2: string;
  private fixedDimCheck: string;
  private periodViewCheck: string;

  public available: Array<SohoSwapListItem> = [];
  public current: Array<SohoSwapListItem> = [];

  public pivotName: string;
  public maxLevels: number;
  public showLevels: number;
  public showTotal: boolean;
  public suppressZeros: boolean;
  public suppressCurPeriod: boolean;
  public preservePD: boolean;

  public hasDimensionLevels: boolean;
  public hasTotalNode: boolean;
  public hasSuppressZeros: boolean;
  public hasSuppressCurPeriod: boolean;
  public showPreservePD: boolean;

  private periodDimensions: Array<string> = [];
  private hasPeriodView: boolean;
  private lastFixedIndex: number;

  private updateState: boolean;
  @ViewChild(SohoSwapListComponent, { static: true }) swapListComponent: SohoSwapListComponent;

  constructor(
    private sohoMessageService: SohoMessageService,
    private lmUniqueIdService: LMUniqueIdService
  ) {
  }

  ngOnInit() {
    this.initialize();
  }

  private initialize(): void {
    this.labelAvailable = Soho.Locale.translate('AvailableDimensions');
    this.labelSelected = Soho.Locale.translate('DimensionTree');
    this.labelLevels = Soho.Locale.translate('ShowDimensionLevels');
    this.labelSuppressZeros = Soho.Locale.translate('SuppressZeros');
    this.labelSuppressCurPeriod = Soho.Locale.translate('SuppressCurrentPeriod');
    this.labelPreservePD = Soho.Locale.translate('PreservePivotDimensionsWhenFiltered');
    this.labelShowTotal = Soho.Locale.translate('ShowTotalNode');
    this.periodDimCheck = Soho.Locale.translate('PeriodDimensionCheck');
    this.periodDimCheck2 = Soho.Locale.translate('PeriodDimensionCheck2');
    this.fixedDimCheck = Soho.Locale.translate('FixedDimensionCheck');
    this.periodViewCheck = Soho.Locale.translate('PeriodViewCheck');

    const availableDims = this.dataViewSet.cubeInfo.availableDims;
    const currentDims = this.dataViewSet.cubeInfo.currentDims;
    this.showLevels = this.dataViewSet.showLevels || 0; // Used by both cube and tree. Not replicated in CubeInfo.
    this.showTotal = this.dataViewSet.cubeInfo.showTotal;
    this.suppressZeros = this.dataViewSet.cubeInfo.suppressZeros;
    this.suppressCurPeriod = this.dataViewSet.cubeInfo.suppressCurPeriod;
    this.preservePD =(this.listState.cubeOverrides?.dimensionOverrides?.preservePD) ? this.listState.cubeOverrides.dimensionOverrides.preservePD : false;
    this.maxLevels = (this.showTotal) ? currentDims.length + 1 : currentDims.length;

    if (this.listSpec.cubeOptions.pivotViews && this.listSpec.cubeOptions.pivotViews.length > 0){
      if (this.dataViewSet.cubeInfo.pivotView) {
        this.pivotName = this.dataViewSet.cubeInfo.pivotView;
      } else {
        this.pivotName = this.listSpec.cubeOptions.pivotViews.find((p) => p.default !== undefined && p.default).name;
      }
    }
    if (this.pivotName) {
      this.labelPivotName = Soho.Locale.translate('PivotView') + ': ' + this.listSpec.cubeOptions.pivotViews.find((p) => p.name === this.pivotName).label;
    }

    this.hasPeriodView = (this.listSpec.cubeOptions.periods !== undefined);
    this.hasSuppressCurPeriod = (this.listSpec.cubeOptions.hasPeriodDimension && !this.hasPeriodView) || this.parentContainer === 'reportpersonalization';
    this.hasDimensionLevels = this.parentContainer === 'cubeviewer';
    this.hasTotalNode = this.parentContainer === 'cubeviewer';
    this.hasSuppressZeros = true;
    this.showPreservePD = this.parentContainer === 'cubeviewer' && (this.listSpec.busListSpec.hasChildHierarchyDims || this.listSpec.busListSpec.searchForm !== undefined);

    this.lastFixedIndex = this.dataViewSet.cubeInfo.lastFixedIndex;

    availableDims.map(m => {
      this.available.push({ id: m.id, value: m.id, text: m.label });
    });

    currentDims.map(m => {
      this.current.push({ id: m.id, value: m.id, text: m.label });
    });

    availableDims.filter(availableDim => availableDim.isPeriod).forEach(item => this.periodDimensions.push(item.id));
    currentDims.filter(currentDim => currentDim.isPeriod).forEach(item => this.periodDimensions.push(item.id));

    this.updateState = false;
  }

  public onBeforeSwap(event: SohoSwapListBeforeSwapEvent) {
    if (!event.moved.items || event.moved.items.length === 0) {
      event.result = false;
      return;
    }

    // Before swap, validate the dimension tree.
    const swapItemId = event.moved.items[ 0 ].id;
    const filteredItem = this.swapListComponent.availableItems.filter((availableItem) => availableItem.id === swapItemId);
    if (filteredItem.length > 0) {
      // Can the selected items be added to the dimension tree?
      const thisArg = this;
      const periodItemsCount = event.moved.items.filter((item) => thisArg.periodDimensions.findIndex((period) => period === item.id) > -1).length;

      // The cubes can have more than one period dimension.
      // A period dimension is prevented from being added to the dimension tree if the CubeView has period Views.
      if (this.hasPeriodView && periodItemsCount > 0) {
        this.printMessage(this.periodViewCheck);
        event.result = false;
        return;
      }

      // *** This Check is not performed since the introduction of multiple period dimension feature
      // 1. Check the number of period dimensions in event items list
      // if (periodItemsCount > 1) {
      //   // Cannot select more than one period dimension
      //   this.printMessage(this.periodDimCheck);
      //   event.result = false;
      //   return;
      // }

      // *** This Check is not performed since the introduction of multiple period dimension feature
      // 2. Is there a period dimension in the selected items list already?
      // if (periodItemsCount === 1) {
      //   let selectedPeriodItems = this.swapListComponent.selectedItems.filter((selectedItem) => thisArg.periodDimensions.findIndex((period) => period === selectedItem.id) > -1);
      //   if (selectedPeriodItems.length > 0 ) {
      //     this.printMessage(this.periodDimCheck2);
      //     event.result = false;
      //     return;
      //   }
      // }
    } else {
      // Can the selected items be removed from the dimension tree?
      // 3. Fixed dimensions cannot be removed from the selected list.
      const firstSelectedIndex = this.swapListComponent.selectedItems.findIndex(selectedItem => selectedItem.id === event.moved.items[ 0 ].id);
      if (firstSelectedIndex <= this.lastFixedIndex) {
        this.printMessage(this.fixedDimCheck);
        event.result = false;
        return;
      }
    }
    event.result = true;
  }

  private printMessage(message: string) {
    const dialogId = 'DimensionTree';
    const buttons = [
      // tslint:disable-next-line - shadowed variable e
      {
        id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.CLOSE ]),
        text:  Soho.Locale.translate(LMDialogButtonKey.CLOSE),
        click: (e, modal) => {
          modal.close();
        }
      }
    ];
    this.sohoMessageService
      .message()
      .message(message)
      .title(Soho.Locale.translate(dialogId))
      .buttons(buttons)
      .open();
  }

  public onDimensionSwapListUpdated(event: SohoSwapListSwapUpdateEvent) {
    // Swap list updated - Get the new dimension tree.
    // let updated = this.swapListComponent.selectedItems;
    this.maxLevels = (this.showTotal) ? this.swapListComponent.selectedItems.length + 1 : this.swapListComponent.selectedItems.length;
    this.updateState = true;

    if (this.listState.cubeOverrides?.fltrDimensions?.length) {
      const dimensionTree = this.swapListComponent.selectedItems.map(m => m.id).join(',');
      const filteredDimensions = this.listState.cubeOverrides.fltrDimensions.filter(dim => dimensionTree.indexOf(dim.fltrDimId) >= 0);
      if (filteredDimensions.length > 0 && !this.preservePD) {
        this.printMessage(Soho.Locale.translate('SetPreservePivotDimensionWhenFiltered'));
      }
    }
  }

  public onDirty(event: any) {
    this.updateState = true;
  }

  public onPristine(event: any) {
    // Checkbox unchecked calls onPristine. The value is changed from the initial state, so set updateState to true.
    this.updateState = true;
  }

  public onReset(): boolean {
    if (Object.keys(this.listState).length > 0 && this.listState.hasOwnProperty('cubeOverrides')) {
      this.listState.cubeOverrides.dimensionOverrides = {};
      return true;
    }
    return false;
  }

  public onApply(): boolean {
    if (this.updateState) {
      this.listState.cubeOverrides = this.listState.cubeOverrides || {};
      this.listState.cubeOverrides.dimensionOverrides = this.getCubeOverrides();
    }
    return this.updateState;
  }

  private getCubeOverrides(): LMCubeDimensionOverrides {
    const cubeDimensionOverrides: LMCubeDimensionOverrides = {};

    const dimensionTree = this.swapListComponent.selectedItems.map(m => m.id).join(',');
    cubeDimensionOverrides.dimensionsOverride = dimensionTree;
    cubeDimensionOverrides.showLevels = this.showLevels;
    cubeDimensionOverrides.suppressZeros = this.suppressZeros;
    cubeDimensionOverrides.showTotal = this.showTotal;
    cubeDimensionOverrides.suppressCurPeriod = this.suppressCurPeriod;
    cubeDimensionOverrides.preservePD = this.preservePD;
    cubeDimensionOverrides.overrideDims = true;

    return cubeDimensionOverrides;
  }

  public hasCubeDimensionsChanged(): boolean {
    // Used by report and personalization
    if (this.updateState) {
      this.listState.cubeOverrides = this.listState.cubeOverrides || {};
      this.listState.cubeOverrides.dimensionOverrides = {};
      let selectedItemsChanged = this.dataViewSet.cubeInfo.currentDims.length !== this.swapListComponent.selectedItems.length;
      if (!selectedItemsChanged) {
        this.swapListComponent.selectedItems.forEach((m, index) => {
          if (m.id !== this.dataViewSet.cubeInfo.currentDims[index].id) {
            selectedItemsChanged = true;
          }
        });
      }
      if (selectedItemsChanged) {
        this.listState.cubeOverrides.dimensionOverrides.dimensionsOverride = this.swapListComponent.selectedItems.map(m => m.id).join(',');
        this.listState.cubeOverrides.pivotView = this.pivotName || undefined;
      }

      if (this.suppressZeros !== this.dataViewSet.cubeInfo.suppressZeros) {
        this.listState.cubeOverrides.dimensionOverrides.suppressZeros = this.suppressZeros;
      }

      if (this.suppressCurPeriod !== this.dataViewSet.cubeInfo.suppressCurPeriod) {
        this.listState.cubeOverrides.dimensionOverrides.suppressCurPeriod = this.suppressCurPeriod;
      }
    }
    return this.updateState;
  }
}
